import React from 'react'
import Spacing from '../spacing/spacing';
import useErrorMessageStyles from './error-message.styles'

interface ErrorMessageProps {
    message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {

    const classes = useErrorMessageStyles();
    return (
        <>
            <Spacing variable="spacing-base" />
            <span className={classes.error__message}>
                {message}
            </span>
        </>
    );
};

export default ErrorMessage;